import css from '@styled-system/css';
import { ThemeStyles } from '@honda-canada/design-system-react';

const themeStyles = new ThemeStyles();

themeStyles.addBaseStyles('ProvinceBannerContainer')(
  css({
    display: 'flex',
    borderRadius: '3px',
    backgroundColor: 'tertiaryLight',
    marginBottom: ['24px', '24px', '36px'],
  }),
);

themeStyles.addBaseStyles('ProvinceBannerText')(
  css({
    display: 'flex',
    padding: '16px',
    color: 'white',
  }),
);

themeStyles.addBaseStyles('CloseIconContainer')(
  css({
    display: 'flex',
    justifyContent: 'flex-end',
    flex: '1',
    padding: '12px',
  }),
);

themeStyles.addBaseStyles('MapMarkerContainer')(
  css({
    marginLeft: '16px',
    paddingTop: '1px',
  }),
);

themeStyles.addBaseStyles('MapMarkerIconWrapper')(
  css({
    width: '12px',
  }),
);

export default themeStyles;
